const LOCAL_STORAGE_LOGGED_IN_USER_DATA = "currentUser";
const LOCAL_STORAGE_JWT_TOKEN = "jwtToken";
const APP_NAME = "Zoella";
const API_RESPONSE_MESSAGE_KEY = "message";
const API_RESPONSE_ERROR_KEY = "error";
const CURRENCY_SYMBOL = "$";
const PHONE_NUMBER_MIN_LENGTH = 13

export {
    APP_NAME,
    LOCAL_STORAGE_LOGGED_IN_USER_DATA,
    LOCAL_STORAGE_JWT_TOKEN,
    API_RESPONSE_MESSAGE_KEY,
    CURRENCY_SYMBOL,
    PHONE_NUMBER_MIN_LENGTH,
    API_RESPONSE_ERROR_KEY
}
